import { motion } from "framer-motion";

const photos = [
  { src: "/images/tray.png", caption: "Le plateau d'argent", arch: true },
  { src: "/images/equipe-mixte.png", caption: "La brigade FK", arch: false },
  { src: "/images/galerie-mariage.png", caption: "Le service en duo", arch: true },
  { src: "/images/duo-service.png", caption: "Le champagne en binôme", arch: false },
  { src: "/images/pour.png", caption: "Le vin d'honneur", arch: true },
  { src: "/images/hotesse.png", caption: "L'hôtesse d'accueil", arch: false },
  { src: "/images/hote.png", caption: "L'hôte souriant", arch: true },
  { src: "/images/salle-moderne1.png", caption: "Le dîner sous verrière", arch: false },
  { src: "/images/salle-moderne2.png", caption: "La salle en fête", arch: false },
];

export const Gallery = () => (
  <section id="galerie" data-testid="gallery-section" className="bg-[#f9f8f6] px-6 py-28 text-[#0a0a0a] lg:px-10 lg:py-40">
    <div className="mx-auto max-w-7xl">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-6 text-[11px] font-semibold uppercase tracking-[0.4em] text-[#aa8c2c]"
      >
        En service
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, delay: 0.1 }}
        className="mb-24 max-w-2xl font-display text-4xl leading-tight tracking-tight sm:text-5xl lg:text-6xl"
      >
        L'élégance se voit, <em className="italic text-[#aa8c2c]">le sourire s'offre.</em>
      </motion.h2>
      <div className="grid gap-10 sm:grid-cols-3 sm:gap-6 lg:gap-10">
        {photos.map((p, i) => (
          <motion.figure
            key={p.src}
            data-testid={`gallery-photo-${i}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 1, delay: i * 0.18, ease: [0.16, 1, 0.3, 1] }}
            className={`group ${i === 1 ? "sm:mt-20" : ""}`}
          >
            <div
              className={`relative overflow-hidden border border-[#0a0a0a]/10 bg-[#141414] ${
                p.arch ? "rounded-t-full" : "rounded-3xl"
              }`}
            >
              <img
                src={p.src}
                alt={p.caption}
                className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#0a0a0a]/20 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
            </div>
            <figcaption className="mt-5 flex items-center gap-3 text-xs font-medium uppercase tracking-[0.3em] text-[#0a0a0a]/50">
              <span className="h-1.5 w-1.5 rotate-45 bg-[#aa8c2c]" />
              {p.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
